import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProjectModel, ProjectShortInfoModel } from 'Pages/knowledge'
import { RequestParams, ResponseCatalog } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { Id } from 'Types/aliases'

export type ProjectState = {
	data: ResponseCatalog<ProjectModel>
	project: ProjectModel
	requestParams: RequestParams
}

export const projectInitialState: ProjectState = {
	data: new ResponseCatalog<ProjectModel>(),
	project: null,
	requestParams: new RequestParams(),
}

export namespace projectNS {
	export type getAllProject = PayloadAction<{
		params?: RequestParams
		callback?: Callback
		errorCallback?: Callback
	}>
	export type setAllProject = PayloadAction<ResponseCatalog<ProjectModel>>
	export type getOneProject = PayloadAction<Id>
	export type setOneProject = PayloadAction<ProjectModel>
	export type createOneProject = PayloadAction<ProjectShortInfoModel>
	export type updateOneProject = PayloadAction<{
		data: ProjectShortInfoModel
		id: number
		callback: Callback
	}>
	export type deleteOneProject = PayloadAction<number>
	export type recoverOneProject = PayloadAction<{ info: number; callback: Callback }>
	export type setProjectRequestParams = PayloadAction<RequestParams>
	export type clearAllProject = PayloadAction
}

export const projectSlice = createSlice({
	name: 'project',
	initialState: projectInitialState,
	reducers: {
		clearAllProject: (state, action: projectNS.clearAllProject) => {
			state.data = new ResponseCatalog<ProjectModel>()
			state.requestParams = new RequestParams()
		},
		setAllProject: (state, action: projectNS.setAllProject) => {
			state.data = action.payload
			state.project = null
		},
		setOneProject: (state, action: projectNS.setOneProject) => {
			state.project = action.payload
			state.data = new ResponseCatalog<ProjectModel>()
		},
		setProjectRequestParams: (state, action: projectNS.setProjectRequestParams) => {
			state.requestParams = action.payload
		},
		getAllProject: (state, action: projectNS.getAllProject) => {},
		getOneProject: (state, action: projectNS.getOneProject) => {},
		createOneProject: (state, action: projectNS.createOneProject) => {},
		updateOneProject: (state, action: projectNS.updateOneProject) => {},
		deleteOneProject: (state, action: projectNS.deleteOneProject) => {},
		recoverOneProject: (state, action: projectNS.recoverOneProject) => {},
	},
})
